// @flow
import * as React from 'react';
import isEqual from 'lodash/isEqual';
import {
  transformParts as addHashtags,
  TRANSFORMER_OPTIONS_KEY as optionsKeyHashtags,
} from 'app/common/react/components/common/TextTransformer/Hashtags';

// Transformers are methods that take an array of parts (usually
// strings and JSX nodes) and outputs the same format.
type TransformerFunction = (parts: Array<React.Node>, options: Object) => Array<React.Node>;

// List out each text transformer that can be used on text. If, when
// using TextTransformer, the transformer's key is non-null in
// the options obj, the transformer will be called. It is currently
// assumed that each transformer can only be called once and that the
// static order is defined based on this list.
const TRANSFORMERS: { [optionsKey: string]: TransformerFunction } = {
  [optionsKeyHashtags]: addHashtags,
};

type Props = {|
  options: Object,
  text: string,
|};

// Multiple features may wish to transform pin title/description
// text. TextTransformer was built as a generic component that
// allows these transformations to work in sequence without conflict.
export default class TextTransformer extends React.Component<Props> {
  shouldComponentUpdate(nextProps: Props) {
    // Performing text transformation is likely more expensive than
    // doing a deep isEqual check on tiny objects, so sCU should save
    // us a small bit of time.
    return !isEqual(this.props, nextProps);
  }

  render() {
    const { text, options } = this.props;

    if (typeof text === 'string' && text.trim() === '') {
      return text;
    }

    let parts: Array<React.Node> = [text];

    for (const transformerKey of Object.keys(TRANSFORMERS)) {
      if (transformerKey in options) {
        const transformer = TRANSFORMERS[transformerKey];
        parts = transformer(parts, options[transformerKey]);
      }
    }

    return <span>{parts}</span>;
  }
}
